import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'creditCardNumber',
  standalone: false,
})
export class CreditCardNumberPipe implements PipeTransform {

  transform(value: string | number): string {
    if (!value) {
      return ''
    }

    const cardNumber = value.toString()

    if (cardNumber.length < 4) {
      return ''
    }

    return `************${cardNumber.slice(-4)}`
  }
}
